<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<br/><p style="text-indent:0em">My father—Martin Knowlson</p>
<br/><p style="text-indent:0em">Grandmother—Jeannette Knowlson</p>
<br/><p style="text-indent:0em">Brother—Harry Knowlson</p>
<br/><p style="text-indent:0em">The NHS, mainly the entire Southmead workforce.</p>
<br/><p style="text-indent:0em">The Knowle West Media Centre Community</p>
<br/><p style="text-indent:0em">Captain Tom hard work to support the NHS also inspired me.</p>
<br/><p style="text-indent:0em">None of the people at either wish to have their names published. But they know who they are.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?47d2940c